import styled from "@emotion/styled";
import { userSelector } from "app/selectors";
import { get } from "lodash";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import config from "../config";

const Styled = styled.div`
  padding-top: 100px;
  iframe {
    width: 1px;
    min-width: 100%;
    border: none;
    height: 800px;
  }
`;

const ClientTest = () => {
  const user = useSelector(userSelector);
  const iframe = useRef(null);

  const clientDomen = config.API_ROOT.startsWith("https://backend.roomster.com.ua") ? "https://module.roomster.com.ua" : "https://client.roomster.com.ua";

  const watchIframeResize = () => {
    const IFRAME_ORIGIN = clientDomen;
    window.addEventListener("message", function (event) {
      if (event.origin === IFRAME_ORIGIN) {
        if (event.data === "scrollToTop") iframe.current?.scrollIntoView();
        else if (event.data?.action === "redirect") {
          window.open(event.data.url, "_blank");
        } else {
          iframe.current.style.height = +event.data + "px";
        }
      }
    });
  };

  return (
    <Styled>
      <iframe ref={iframe} onLoad={watchIframeResize} style={{ width: "1px", minWidth: "100%", minHeight: "155px" }} src={`${clientDomen}/${localStorage.locale}/${get(user, "activeHotelId")}`} title="client"></iframe>
    </Styled>
  );
};

export default ClientTest;
